// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-tabs {\n  width: 30%;\n}\n.van-tab--active {\n  font-weight: bold !important;\n  color: #C99700 !important;\n}", ""]);
// Exports
module.exports = exports;
